// reducer.js
import {
  FETCH_COMPANY_REQUEST,
  FETCH_COMPANY_SUCCESS,
  FETCH_COMPANY_FAILURE,
} from './actions';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMPANY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_COMPANY_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_COMPANY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default companyReducer;
